
import {
  defineComponent, onMounted, computed, watch,
} from 'vue';
import { useStore } from 'vuex';
import Hero from '@/components/Hero.vue';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Tour from '@/components/Tour.vue';

export default defineComponent({
  name: 'App',
  components: {
    Hero,
    Error,
    Loading,
    Tour,
  },
  setup() {
    const $store = useStore();
    const isInitialized = computed(() => $store.state.isInitialized);
    const tour = computed(() => $store.state.tour);
    const { isError, isLoading } = $store.getters;

    onMounted(() => {
      $store.dispatch('initialize').then(() => $store.dispatch('search'));
    });

    const context = computed(() => $store.getters.context);
    return {
      isInitialized,
      isError,
      isLoading,
      context,
      tour,
    };
  },
});
